import { render, staticRenderFns } from "./CRMprofil.vue?vue&type=template&id=0f15953e&"
import script from "./CRMprofil.vue?vue&type=script&lang=js&"
export * from "./CRMprofil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports